import React from "react";

// KyberBusiness uses plain section labels, so this is mostly a passthrough — kept
// for parity with the design-doc shell and reused by the Start Menu / mobile nav.
export function plainLabel(title) {
  return title;
}

export default function DesktopIcon({ entry, onActivate }) {
  return (
    <button
      type="button"
      className="win98-desktop-icon win-focus"
      onClick={onActivate}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onActivate();
        }
      }}
      title={`${plainLabel(entry.title)} (click to open)`}
    >
      <span className="win98-desktop-icon-glyph" aria-hidden="true">
        {entry.icon}
      </span>
      <span className="win98-desktop-icon-label">{plainLabel(entry.title)}</span>
    </button>
  );
}
